import * as yup from 'yup';

export const CreateAppointmentNoteSchema = yup.object().shape({
  sellerNote: yup.string().required('Please enter note'),
});
